/* Copyright Information: Created by BuyGroup */
import Api from "../Api";

export const categoryList = () => {
  return Api.get("category")
    .then((res) => res.data)
    .catch((err) => console.log("error in category list data ", err));
};
/* Copyright Information: Created by BuyGroup */
